<template>
<div
  class="form-group">
  <label for="newsletter-type-id">
    {{ newsletterTypeLbl }}
  </label>

  <!-- Hacky implementation of multiple -->
  <select
    :name="selectName"
    id="newsletter-type-id"
    class="form-control"
    v-if="newsletter_types && multiple"
    ref="newsletterTypesSelect"
    v-on:change="newsletterTypesChanged"
    multiple
  >
    <option
      v-for="newsletter_type in newsletter_types"
      v-bind:value="newsletter_type.id"
      :selected="isSelected(newsletter_type.id)"
     >
      {{ displayName(newsletter_type) }}
    </option>
  </select>
  <select
    :name="selectName"
    id="newsletter-type-id"
    class="form-control"
    ref="newsletterTypesSelect"
    v-if="newsletter_types && !multiple"
  >
    <option
      value=""
      v-if="!selectLbl"
    >
      Select a {{ newsletterTypeLbl }}
    </option>
    <option
      v-for="newsletter_type in newsletter_types"
      v-bind:value="newsletter_type.id"
      :selected="newsletter_type.id == newsletterTypeId"
     >
      {{ displayName(newsletter_type) }}
    </option>
  </select>
</div>
</template>

<script>
import NewsletterTypesMixin from '@/mixins/NewsletterTypesMixin'

import NewsletterTypesStore from '@/stores/NewsletterTypesStore'

export default {
  data () {
    let state = NewsletterTypesStore.state
    state.newsletter_type_id = undefined

    return state
  },

  computed: {
    resourceName () {
      return this.resource || 'newsletter'
    },

    selectName () {
      return this.resourceName + '[' + this.resourceId + ']'
    }
  },

  mixins: [
    NewsletterTypesMixin
  ],

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    newsletterTypeId: {
      type: [ Number, String ],
      default: undefined
    },

    newsletterTypeLbl: {
      type: String,
      default: 'Newsletter Type'
    },

    resource: {
      type: Object,
      default: () => { return undefined }
    },

    resourceId: {
      type: String,
      default: 'newsletter_type_id'
    },

    selectedNewsletterTypeIds: {
      type: Array,
      default: () => []
    },

    selectLbl: {
      type: Boolean,
      default: false
    },

    showStatus: {
      type: Boolean,
      default: false
    }
  },

  created () {
    this.newsletter_type_id = this.newsletterTypeId

    this.getNewsletterTypes().then((resp) => {
      this.newsletter_types = resp
    })
  },

  methods: {
    isSelected (newsletterTypeId) {
      return this.selectedNewsletterTypeIds.includes(newsletterTypeId)
    },

    newsletterTypesChanged (ev) {
      console.log('newsletterTypesChanged!')
      const newsletterTypeIds = [...this.$refs.newsletterTypesSelect.options].filter(
        option => option.selected
      ).map(option => option.value)

      this.$emit('newsletter-types-changed', newsletterTypeIds)
    },

    displayName (nt) {
      return nt.name + (this.showStatus && this.isPrivate(nt) ? ` (${this.hasStatus(nt)})` : '')
    },

    isPrivate (nt) {
      return nt.inactive && !nt.visible
    },

    hasStatus (nt) {
      return this.isPrivate(nt) ? 'PRIVATE' : ''
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypePicker.vue